import { render, staticRenderFns } from "./alipayAPIConfigure.vue?vue&type=template&id=5dfed9f4&scoped=true"
import script from "./alipayAPIConfigure.vue?vue&type=script&lang=js"
export * from "./alipayAPIConfigure.vue?vue&type=script&lang=js"
import style0 from "./alipayAPIConfigure.vue?vue&type=style&index=0&id=5dfed9f4&prod&scoped=true&lang=css"
import style1 from "./alipayAPIConfigure.vue?vue&type=style&index=1&id=5dfed9f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfed9f4",
  null
  
)

export default component.exports